const GET_MAP_IT_LINK_NAVIGATION = "GET_MAP_IT_LINK_NAVIGATION";

export default function(state = null, action) {
  switch (action.type) {
    case GET_MAP_IT_LINK_NAVIGATION:
      return action.payload;

    default:
      return state;
  }
}
